<template>
  <div class="substitute-invoice">
    <div class="top-container">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="80px"
      >
        <div class="row">
          <el-form-item label="食堂：" prop="canteen" >
            <el-select
              v-model="ruleForm.canteen"
              placeholder="请选择"
              class="w200"
              clearable
              @change="changeCanteen"
            >
              <el-option
                v-for="item in canteenList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间：" prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              class="white w240"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn">
            <el-button class="btn-gray" @click="resetForm('ruleForm')">重置</el-button>
            <el-button class="btn-blue" type="primary" @click="search">确认</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="container">
      <div class="table" v-if="tableData.length > 0">
        <el-table
          :data="tableData"
          :span-method="objectSpanMethod"
        >
          <el-table-column label="序号" width="80" prop="sort"></el-table-column>
          <el-table-column label="物料名称" min-width="150" prop="name">
            <template slot-scope="scope">
              <p v-if="!scope.row.isFlag">{{scope.row.name}}</p>
              <div v-else class="supplier-class-high">
                <span>
                  {{scope.row.supplierName}}
                </span>
                <span>
                  {{`小计：${scope.row.amount}`}}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.lable"
            :min-width="item.width"
            show-overflow-tooltip
          />
          <el-table-column label="金额（元）" width="180" class-name="sub-total-head" prop="amount">
            <template slot-scope="scope">
              <p class="sub-total">{{scope.row.isFlag ? `小计：${scope.row.amount}`: scope.row.amount}}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="foot" v-if="tableData.length > 0">
        <el-button class="btn-border-text-blue" type="primary" @click="goBack">返回</el-button>
        <el-button
          type="text"
          class="btn-blue"
          @click="confirmPrint"
          >确认打印</el-button
        >
        <div class="totalPrice">合计(元)：{{totalPrice}}</div>
      </div>
      
      <div class="nothing" v-if="tableData.length == 0">
        <div>
          <div>
            <img src="../../../../../assets/nothing.png">
          </div>
          <p>暂无数据</p>
        </div>
      </div>
    </div>
    
    <!-- 打印 -->
    <el-dialog class="printer-dialog" top="10vh" title="打印" :visible.sync="printerDialog" width="860px" 
    :before-close="closePrinterDialog">
      <div>
        <el-steps :active="active" align-center>
          <el-step :title="item.roleName" v-for="(item,index) in procedureList" :key="index">
            <template slot="title">
              <span>{{item.name}}</span>
            </template>
          </el-step>
        </el-steps>
      </div>
      <div v-if="active == 1" class="input-container">
        <el-form
          :model="ruleInputForm"
          :rules="rules"
          ref="ruleInputForm"
          class="demo-ruleInputForm"
        >
          <el-form-item label="就餐人数" prop="peopleNums">
            <el-input
              class="gray white"
              v-model="ruleInputForm.peopleNums"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="active == 2" class="printer" id="printer">
        <div>
          <p class="printer-title">采购代发票</p>
          <div class="printer-message">
            <ul class="list">
              <li class="list-item">食堂：{{ canteenName }}</li>
              <li class="list-item">采购日期：{{ ruleForm.date }}</li>
              <li class="list-item">就餐人数：{{ ruleInputForm.peopleNums }}</li>
              <li class="list-item">就餐人均（元/人）：{{ perCapita }}</li>
            </ul>
          </div>
          <div class="table">
            <el-table
            class="table-printer"
            :data="tableData"
            border
            :class="tableData.length > 6?'no-border':''"
            :span-method="objectSpanMethod"
             style="width:100%">
              <el-table-column label="序号" width="80" prop="sort"></el-table-column>
              <el-table-column label="物料名称" min-width="150" prop="name">
                <template slot-scope="scope">
                  <p v-if="!scope.row.isFlag">{{scope.row.name}}</p>
                  <div v-else class="supplier-class">
                    <span>
                      {{scope.row.supplierName}}
                    </span>
                    <span>
                      {{`小计：${scope.row.amount}`}}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(item, index) in tableTitleList"
                :key="index"
                :prop="item.prop"
                :label="item.lable"
                :width="item.width"
                show-overflow-tooltip
              />
              <el-table-column label="金额（元）" prop="amount" width="200" class-name="sub-total-head">
                <template slot-scope="scope">
                  <p class="sub-total">{{scope.row.isFlag ? `小计：${scope.row.amount}`: scope.row.amount}}</p>
                </template>
              </el-table-column>
            </el-table>
            <div class="print-total-price">
              <span class="total-title">合计</span>
              <span class="total-content">{{totalPrice}}</span>
            </div>
          </div>
          <div class="sign-container">
            <div class="sign-content">
              大/中队主管
              <span class="under-line"></span>
            </div>
            <div class="sign-content">验收人：
              <span class="under-line"></span>
            </div>
            <div class="sign-content">采购人：
              <span class="under-line"></span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer" v-if="active == 1" >
        <el-button class="btn-white" @click="closePrinterDialog">取消</el-button>
        <el-button class="btn-blue" @click="next('ruleInputForm')">下一步</el-button>
      </div>
      <div class="footer" v-if="active == 2" >
        <el-button class="btn-white" @click="closePrinterDialog">取消</el-button>
        <el-button class="btn-blue" v-print="'#printer'">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import { keepTwoDecimal } from "@/common/js/utils.js"
import Canteen from "@/models/canteen.js";
import Purchase from "@/models/purchase.js"
import { statusMixins } from "@/common/mixins/status/status.js";
export default {
  mixins: [statusMixins],

  data() {
    return {
      ruleForm: {
        canteen: '',
        date: '',
      },
      canteenList: [],
      tableData: [],
      tableTitleList: [
        { prop: "unitType", lable: "单位", width: "90" },
        { prop: "nums", lable: "数量", width: "80" },
        { prop: "unitPrice", lable: "单价", width: "100" },
        { prop: "discount", lable: "优惠金额", width: "100" },
      ],
      printerDialog: false,
      totalPrice: '',
      perCapita: '',
      canteenName: '',
      active: 1,
      procedureList:[
        {id:1, name: '录入信息'},
        {id:2, name: '打印确认'}
      ],
      ruleInputForm: {
        peopleNums: '',
      },
      rules: {
        peopleNums: [
          { required: true, message: "请输入人数", trigger: "blur" },
        ],
      },
    }
  },

  created() {
    config()
    this.initCanteenList()
  },

  methods: {
    initTableList() {
      let data = {}
      data.canteenId = this.ruleForm.canteen
      data.date = this.ruleForm.date
      Purchase.getSubstituteList(data).then(res => {
        if (res.success) {
          let arr = []
          let {totalAmount, dataList} = res.result
          dataList.map(i => {
            i.supplierDataList.map((v, index) => {
              let obj = {}
              obj.sort = v.sort
              obj.materialId = v.materialId
              obj.name = v.materialName
              obj.nums = v.checkNum
              obj.discount = v.discount? v.discount : ''
              obj.unitType = this.UNIT[v.unitType]
              obj.unitPrice = v.checkUnitPrice
              obj.amount = v.checkSubtotal
              obj.isFlag = 0
              arr.push(obj)
              if (index == i.supplierDataList.length-1) {
                let obj2 = {}
                obj2.sort = ''
                obj2.materialId = ''
                obj2.name = ''
                obj2.nums = ''
                obj2.unitType = ''
                obj2.discount = ''
                obj2.amount = i.subtotal
                obj2.supplierName = `供应商：${i.supplierName}`
                obj2.isFlag = 1
                arr.push(obj2)
              }
            })
          })
          this.tableData = arr
          this.totalPrice = totalAmount
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 食堂数据 */
    initCanteenList() {
      Canteen.getCanteenNoPageList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            arr.push(obj)
          })
          this.canteenList = arr
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    },

    changeCanteen(v) {
      let obj = this.canteenList.find(i => {return v == i.id})
      this.canteenName = obj.name
    },

    // 表格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.isFlag) {
        if (columnIndex === 1) {
          return [1, 7];
        } else {
          return [0, 0];
        }
      }
    },
    
    /* 重置 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /* 搜索 */
    search() {
      if (!this.ruleForm.canteen) return this.$message.error('请选择食堂')
      if (!this.ruleForm.date) return this.$message.error('请选择日期')
      this.initTableList();
    },

    goBack() {
      this.$router.go(-1)
    },

    confirmPrint() {
      this.printerDialog = true
    },

    closePrinterDialog() {
      this.active = 1
      this.ruleInputForm.peopleNums = ''
      this.perCapita = ''
      this.printerDialog = false
    },

    next(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let perCapita = this.totalPrice / Number(this.ruleInputForm.peopleNums)
          this.perCapita = keepTwoDecimal(perCapita)
          this.active = 2
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
}
</script>

<style lang='scss'>
.substitute-invoice {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: $bg-WhiteSmoke;
  .top-container {
    box-sizing: border-box;
    background: $bg-white;
    padding: 10px;
    .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      margin-bottom: 0px
    }
    .row {
      @include flex-start;
      flex-wrap: wrap;
      .btn {
        margin-left: 30px;
        .el-form-item__content {
          margin-left: 0px!important;
          display: flex;
        }
      }
    }
    .el-select {
      .el-input__prefix, .el-input__suffix {
        top: -3px;
      }
    }
  }
  .container {
    flex: 1;
    margin-top: 20px;
    padding: 20px 20px 80px 20px;
    box-sizing: border-box;
    background: $bg-white;
    position: relative;
    .foot {
      position: fixed;
      width: calc(100% - 242px);
      bottom: 0;
      left: 221px;
      z-index: 99;
      .totalPrice {
        position: absolute;
        right: 100px;
        font-size: $fs-medium-s;
        font-weight: bold;
        color: $color-BlackGrey;
      }
    }
  }
  
  .nothing {
    position: absolute;
    left: 52%;
    top: 50%;
    transform: translate(-50%,-50%);
    img {
      width: 157px;
      height: 157px;
    }
    p {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      margin-top: 24px;
    }
  }

  .printer-dialog,
  .table {
    .sub-total-head {
      text-align: right;
      padding-right: 30px!important;
      .sub-total {
        padding-right: 30px!important;
      }
    }
  }
  .el-steps {
    margin-bottom: 10px;
  }

  .el-dialog__header,
  .el-dialog__footer {
    border: none;
  }
  .el-dialog__body {
    padding: 0px 20px;
    min-height: 404px;
    .el-table {
      max-height: 261px!important;
      overflow-y: auto;
    }
  }
  .el-table .cell, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
    padding-left: 16px;
  }
  
  .el-table__header-wrapper {
    background: $bg-table;
    .el-table__header {
      tr {
        th {
          background: $bg-table;
          padding: 0;
          height: 44px;
          .cell {
            color: $color-BlackGrey;
            line-height: 16px;
            padding: 8px 16px;
            font-size: $fs-small-l;
          }
        }
      }
    }
  }
  .table .el-table .el-table__body-wrapper .el-table__body tr td,
  .table .el-table .el-table__body-wrapper .el-table__body tr {
    height: 32px;
  }
  .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
    height: 32px;
    line-height: 32px;
  }
  .el-table__footer-wrapper {
    tbody td {
      background: $bg-white;
      border-bottom: 0; 
    }
  }
  .input-container {
    @include flex-center;
    .demo-ruleInputForm {
      .el-form-item {
        width: 476px;
        .el-form-item__content {
          .el-date-editor.el-input, 
          .el-date-editor.el-input__inner {
            width: 100%
          }
        }
      }
    }
  }
  .el-dialog__footer {
    padding: 0px 20px 0px 0px;
    border-top: 1px solid $bg-ShallowLightSnow;
    @include flex-end;
  }
  .printer-dialog .footer {
    height: 72px;
    line-height: 72px;
    text-align: right;
  }
  
  .el-dialog__footer {
    .dialog-footer {
      width: 100%;
      @include flex-between;
    }
  }
  
  .sign-container {
    width: auto!important;
    justify-content: flex-start!important;
    position: absolute;
    z-index: 111;
  }
  .under-line {
    width: 100px!important;
  }
  .sign-content {
    margin-right: 44px;
  }
  .printer-dialog .el-table__footer-wrapper {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }
  .printer-dialog {
    .supplier-class {
      padding-right: 60px!important;
    }
    .print-total-price {
      padding-right: 60px!important;
    }
    .no-border {
      .el-table__row:nth-last-child(1) td {
        border-bottom: none!important;
      }
    }
  }
  .table {
    .supplier-class-high {
      display: flex;
      justify-content: space-between;
      padding-right: 60px;
      background: $bg-ChangeDepartmentTree;
    }
  }
}
</style>


<style midia="print">
#printer .printer-title {
  height: 64px;
  font-size: 24px;
  line-height: 64px;
  text-align: center;
  margin-bottom: 20px;
}
#printer .el-table--border td, 
#printer .el-table--border th,
#printer .el-table__header-wrapper .el-table__header tr th {
  border-right-color: #000;
}
#printer .supplier-class {
  display: flex;
  justify-content: space-between;
  padding-right: 100px;
}
#printer .print-total-price {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  border: 1px solid #000;
  border-top: none;
  box-sizing: border-box;
  padding-left: 14px;
  padding-right: 16px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
#printer .table .el-table .el-table__body-wrapper .el-table__body tr td,
#printer .table .el-table .el-table__body-wrapper .el-table__body tr {
  height: 32px;
}
#printer .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
  height: 32px;
  line-height: 32px;
}
#printer .printer-message {
  width: 100%;
}
#printer .printer-message .list {
  display: flex;
  justify-content: space-between;
}
#printer .printer-message .list .list-item {
  font-size: 12px;
  padding-bottom: 16px;
  text-align: left;
}
#printer .table .el-table {
  border: 1px solid #000;
}
#printer .el-table th.is-leaf {
  border-bottom: 1px solid #000;
}
#printer .table .el-table td {
  border-bottom: 1px solid #000;
}
#printer .el-table__footer-wrapper td {
  border-top: 1px solid #000;
}
#printer .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
  height: auto;
  line-height: 20px;
  font-size: 12px;
}
#printer .table th {
  width: 60px;
}
#printer .sub-total-head {
  text-align: right;
  padding-right: 80px;
}
#printer .sub-total {
  padding-right: 20px;
}
#printer .sign-container {
  width: 100%;
  margin-top: 30px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  display: flex;
  justify-content: space-between;
}
#printer .under-line {
  display: inline-block;
  width: 100px;
  border-bottom: 1px solid #000;
}
</style>